import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import Flex from 'ui/Flex'
import PropTypes from 'prop-types'

const StyledFlex = styled(Flex)`
    background: ${({ background }) => background};
    border-radius: 8px;
    border: 1px solid transparent;
    padding: 1px;
`
const SwitchButton = styled.button`
    font-size: 16px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    margin: 0;
    flex: 50%;
    border-radius: 8px;
    border: none;
    background: ${({ bgColor }) => bgColor};
    color: ${(props) => (props.color ? props.color : 'white')};
    cursor: pointer;
    text-transform: capitalize;

    ${(props) =>
        props.active &&
        css`
            z-index: 2;
            background: ${(props) =>
                props.activeBgColor ? props.activeBgColor : 'white'};
            font-weight: bold;
            box-shadow: 0 3px 8px #0000001f;
            color: ${({ activeColor }) => activeColor};
        `};
`

const Divider = styled.div`
    width: 1px;
    height: 20px;
    background: #0000000a;
    z-index: 1;
    position: relative;
    left: 1px;
`

const SmallMultiSwitcher = ({
    value = '',
    optionList = [],
    onChange = (f) => f,
    bgColor = 'none',
    color = 'white',
    activeColor = 'white',
    activeBgColor = 'black',
    mainColor = '#0000001a',
}) => {
    return (
        <StyledFlex background={mainColor}>
            {optionList.map((option, index) => (
                <Fragment key={index}>
                    <SwitchButton
                        bgColor={bgColor}
                        color={color}
                        activeBgColor={activeBgColor}
                        activeColor={activeColor}
                        active={value === option.name}
                        onClick={
                            option.action
                                ? option.action
                                : () => onChange(option.name)
                        }
                    >
                        {option.title}
                    </SwitchButton>
                    {value !== option.name &&
                        index < optionList.length - 1 && <Divider />}
                </Fragment>
            ))}
        </StyledFlex>
    )
}

SmallMultiSwitcher.propTypes = {
    value: PropTypes.string.isRequired,
    optionList: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    bgColor: PropTypes.string,
    color: PropTypes.string,
    activeBgColor: PropTypes.string,
    activeColor: PropTypes.string,
    mainColor: PropTypes.string,
}

export default SmallMultiSwitcher
